export const scssPattern = `@import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap");

$dark: #212529;
$dark-color: #f5f5f5;
$light: #fefeff;
$light-color: #3e363f;
$primary: #007bff;
$primary-color: #ffffff;
$success: #28a745;
$success-color: #ffffff;
$warning: #ffc107;
$warning-color: #3e363f;
$info: #17a2b8;
$info-color: #ffffff;
$danger: #dc3545;
$danger-color: #f5f5f5;
$secondary: #6c757d;
$secondary-color: #ffffff;
$grayJet: #333234;
$yellowCorn: #ffec70;
$orange: #fe9000;

$th_font_size: 15px;
$td_font_size: 16px;

.calendar-wrapper {
    font-family: "Quicksand", sans-serif !important;
    font-weight: 500;
    overflow-x: auto;
    width: 100%;
    height: auto;
    text-align: center;
    box-sizing: border-box;
    & * {
        box-sizing: border-box;
    }
    & .jump-to-date-container {
        width: 100%;
        height: auto;
        line-height: 1.7;
        margin: 30px 0;
        & span {
            font-size: 20px;
        }
        & select {
            padding: 8px 10px;
            margin: 0 10px;
            font-size: 16px;
            border-radius: 10px;
            outline: none;
            background-color: $primary;
            color: $primary-color;
        }
        & select:focus {
            box-shadow: 0 0 5px rgba(81, 203, 238, 1);
            border: 1px solid rgba(81, 203, 238, 1);
            &::-webkit-scrollbar {
                width: 0px;
            }
        }
    }
    & .calendar-title-container {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;
        padding: 15px 0;
        & .arrow:hover,
        & .arrow:hover {
            cursor: pointer;
            opacity: 0.8;
            transform: scale(1.2);
        }
    }
    & table {
        border-collapse: disabled;
        table-layout: fixed;
        border-spacing: 15px;
        width: 100%;
        height: auto;
        & thead th {
            font-size: $th_font_size;
        }
        & tbody td {
            font-size: $td_font_size;
            padding: 5px;
        }
        & tbody {
            & .cell {
                border: 1px solid gray;
            }
            & .cell-today {
                background: $info;
                color: $info-color;
            }
            & .cell-sat-sun {
                background: rgba(158, 157, 157, 0.555);
                color: white;
            }
            & .cell-selected {
                background: rgba(90, 194, 4, 0.644);
                color: white;
            }
            & .cell-selected.today {
                color: $primary;
                font-weight: bold;
                box-shadow: inset 1px 1px $primary, inset -1px -1px $primary;
            }
            & .cell:hover,
            & .cell-today:hover,
            & .cell-today:hover,
            & .cell-sat-sun:hover,
            & .cell-selected:hover {
                background: $orange !important;
                color: white !important;
                cursor: pointer;
                transform: scale(1.1);
                font-weight: bold;
                border: none;
            }
        }
    }
}

.calendar-wrapper.bg-dark {
    background-color: $dark;
    color: $dark-color;
    & table {
        & tbody {
            & .cell-selected.today {
                color: $dark-color !important;
                box-shadow: inset 1px 1px $dark-color, inset -1px -1px $dark-color;
            }
            & .cell:hover,
            & .cell-today:hover,
            & .cell-today:hover,
            & .cell-sat-sun:hover,
            & .cell-selected:hover {
                background: $orange !important;
                color: white !important;
            }
        }
    }
}

.calendar-wrapper.bg-primary {
    background-color: $light;
    color: $light-color;
}

.calendar-wrapper.bg-danger {
    background-color: $danger;
    color: $danger-color;
}

.calendar-wrapper.bg-info {
    background-color: $info;
    color: $info-color;
}

.calendar-wrapper.bg-secondary {
    background-color: $secondary;
    color: $secondary-color;
}

.calendar-wrapper.bg-primary,
.calendar-wrapper.bg-info,
.calendar-wrapper.bg-danger,
.calendar-wrapper.bg-secondary {
    & .jump-to-date-container {
        & select {
            background-color: $light;
            color: $light-color;
        }
    }
    & table {
        & tbody {
            & .cell,
            & .cell-sat-sun {
                border: 1px solid $primary-color;
            }
            & .cell-selected.today {
                color: $dark !important;
                box-shadow: inset 1px 1px $dark, inset -1px -1px $dark;
            }
        }
    }
}

.calendar-wrapper.bg-success {
    background-color: $success;
    color: $success-color;
    & .jump-to-date-container {
        & select {
            background-color: $light;
            color: $light-color;
        }
    }
    & table {
        & tbody {
            & .cell {
                background: rgba(158, 157, 157, 0.555);
                color: $dark-color;
            }
            & .cell-sat-sun {
                background-color: $grayJet;
                color: $dark-color;
            }
            & .cell-selected {
                background: rgba(90, 194, 4, 0.644);
                color: white;
                box-shadow: inset 1px 1px $dark-color, inset -1px -1px $dark-color;
            }
            & .cell-selected.today {
                color: $yellowCorn;
                box-shadow: inset 1px 1px $yellowCorn, inset -1px -1px $yellowCorn;
            }
        }
    }
}

.calendar-wrapper.bg-warning {
    background-color: $warning;
    color: $warning-color;
    & table {
        & tbody {
            & .cell:hover,
            & .cell-today:hover,
            & .cell-today:hover,
            & .cell-sat-sun:hover,
            & .cell-selected:hover {
                background: $dark !important;
                color: $dark-color !important;
            }
        }
    }
}

@media (max-width: 700px) {
    .calendar-wrapper {
        & table {
            border-spacing: 8px;
        }
    }
}`

export const cssPattern = `@import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap");
.calendar-wrapper {
    font-family: "Quicksand", sans-serif !important;
    font-weight: 500;
    overflow-x: auto;
    width: 100%;
    height: auto;
    text-align: center;
    box-sizing: border-box;
}
.calendar-wrapper * {
    box-sizing: border-box;
}
.calendar-wrapper .jump-to-date-container {
    width: 100%;
    height: auto;
    line-height: 1.7;
    margin: 30px 0;
}
.calendar-wrapper .jump-to-date-container span {
    font-size: 20px;
}
.calendar-wrapper .jump-to-date-container select {
    padding: 8px 10px;
    margin: 0 10px;
    font-size: 16px;
    border-radius: 10px;
    outline: none;
    background-color: #007bff;
    color: #fff;
}
.calendar-wrapper .jump-to-date-container select:focus {
    box-shadow: 0 0 5px #51cbee;
    border: 1px solid #51cbee;
}
.calendar-wrapper .jump-to-date-container select:focus::-webkit-scrollbar {
    width: 0px;
}
.calendar-wrapper .calendar-title-container {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    padding: 15px 0;
}
.calendar-wrapper .calendar-title-container .arrow:hover,
.calendar-wrapper .calendar-title-container .arrow:hover {
    cursor: pointer;
    opacity: 0.8;
    transform: scale(1.2);
}
.calendar-wrapper table {
    border-collapse: disabled;
    table-layout: fixed;
    border-spacing: 15px;
    width: 100%;
    height: auto;
}
.calendar-wrapper table thead th {
    font-size: 15px;
}
.calendar-wrapper table tbody td {
    font-size: 16px;
    padding: 5px;
}
.calendar-wrapper table tbody .cell {
    border: 1px solid gray;
}
.calendar-wrapper table tbody .cell-today {
    background: #17a2b8;
    color: #fff;
}
.calendar-wrapper table tbody .cell-sat-sun {
    background: rgba(158, 157, 157, 0.555);
    color: white;
}
.calendar-wrapper table tbody .cell-selected {
    background: rgba(90, 194, 4, 0.644);
    color: white;
}
.calendar-wrapper table tbody .cell-selected.today {
    color: #007bff;
    font-weight: bold;
    box-shadow: inset 1px 1px #007bff, inset -1px -1px #007bff;
}
.calendar-wrapper table tbody .cell:hover,
.calendar-wrapper table tbody .cell-today:hover,
.calendar-wrapper table tbody .cell-today:hover,
.calendar-wrapper table tbody .cell-sat-sun:hover,
.calendar-wrapper table tbody .cell-selected:hover {
    background: #fe9000 !important;
    color: white !important;
    cursor: pointer;
    transform: scale(1.1);
    font-weight: bold;
    border: none;
}
.calendar-wrapper.bg-dark {
    background-color: #212529;
    color: #f5f5f5;
}
.calendar-wrapper.bg-dark table tbody .cell-selected.today {
    color: #f5f5f5 !important;
    box-shadow: inset 1px 1px #f5f5f5, inset -1px -1px #f5f5f5;
}
.calendar-wrapper.bg-dark table tbody .cell:hover,
.calendar-wrapper.bg-dark table tbody .cell-today:hover,
.calendar-wrapper.bg-dark table tbody .cell-today:hover,
.calendar-wrapper.bg-dark table tbody .cell-sat-sun:hover,
.calendar-wrapper.bg-dark table tbody .cell-selected:hover {
    background: #fe9000 !important;
    color: white !important;
}
.calendar-wrapper.bg-primary {
    background-color: #fefeff;
    color: #3e363f;
}
.calendar-wrapper.bg-danger {
    background-color: #dc3545;
    color: #f5f5f5;
}
.calendar-wrapper.bg-info {
    background-color: #17a2b8;
    color: #fff;
}
.calendar-wrapper.bg-secondary {
    background-color: #6c757d;
    color: #fff;
}
.calendar-wrapper.bg-primary .jump-to-date-container select,
.calendar-wrapper.bg-info .jump-to-date-container select,
.calendar-wrapper.bg-danger .jump-to-date-container select,
.calendar-wrapper.bg-secondary .jump-to-date-container select {
    background-color: #fefeff;
    color: #3e363f;
}
.calendar-wrapper.bg-primary table tbody .cell,
.calendar-wrapper.bg-primary table tbody .cell-sat-sun,
.calendar-wrapper.bg-info table tbody .cell,
.calendar-wrapper.bg-info table tbody .cell-sat-sun,
.calendar-wrapper.bg-danger table tbody .cell,
.calendar-wrapper.bg-danger table tbody .cell-sat-sun,
.calendar-wrapper.bg-secondary table tbody .cell,
.calendar-wrapper.bg-secondary table tbody .cell-sat-sun {
    border: 1px solid #fff;
}
.calendar-wrapper.bg-primary table tbody .cell-selected.today,
.calendar-wrapper.bg-info table tbody .cell-selected.today,
.calendar-wrapper.bg-danger table tbody .cell-selected.today,
.calendar-wrapper.bg-secondary table tbody .cell-selected.today {
    color: #212529 !important;
    box-shadow: inset 1px 1px #212529, inset -1px -1px #212529;
}
.calendar-wrapper.bg-success {
    background-color: #28a745;
    color: #fff;
}
.calendar-wrapper.bg-success .jump-to-date-container select {
    background-color: #fefeff;
    color: #3e363f;
}
.calendar-wrapper.bg-success table tbody .cell {
    background: rgba(158, 157, 157, 0.555);
    color: #f5f5f5;
}
.calendar-wrapper.bg-success table tbody .cell-sat-sun {
    background-color: #333234;
    color: #f5f5f5;
}
.calendar-wrapper.bg-success table tbody .cell-selected {
    background: rgba(90, 194, 4, 0.644);
    color: white;
    box-shadow: inset 1px 1px #f5f5f5, inset -1px -1px #f5f5f5;
}
.calendar-wrapper.bg-success table tbody .cell-selected.today {
    color: #ffec70;
    box-shadow: inset 1px 1px #ffec70, inset -1px -1px #ffec70;
}
.calendar-wrapper.bg-warning {
    background-color: #ffc107;
    color: #3e363f;
}
.calendar-wrapper.bg-warning table tbody .cell:hover,
.calendar-wrapper.bg-warning table tbody .cell-today:hover,
.calendar-wrapper.bg-warning table tbody .cell-today:hover,
.calendar-wrapper.bg-warning table tbody .cell-sat-sun:hover,
.calendar-wrapper.bg-warning table tbody .cell-selected:hover {
    background: #212529 !important;
    color: #f5f5f5 !important;
}
@media (max-width: 700px) {
    .calendar-wrapper table {
        border-spacing: 8px;
    }
}`